import React from 'react'

import Register from './Register'


export default function () {
  return (
    <div>
     
     <Register/>
     
    </div>
  )
}
